import { Pipe, PipeTransform } from '@angular/core';
import { GoogleDurationPipeFormatType } from '../../types/google/google-duration-pipe-format.type';

@Pipe({
  name: 'googleDuration',
})
export class GoogleDurationPipe implements PipeTransform {
  transform(
    value: number,
    arg1: 'ms' | 's' = 's',
    arg2: GoogleDurationPipeFormatType = 'hhmm',
  ): string {
    const seconds =
      arg1 === 'ms' ? Math.floor((value / 1000) % 60) : Math.floor(value % 60);
    const minutes =
      arg1 === 'ms'
        ? Math.floor((value / (1000 * 60)) % 60)
        : Math.floor((value / 60) % 60);
    const hours =
      arg1 === 'ms'
        ? Math.floor(value / (1000 * 60 * 60))
        : Math.floor(value / 60 / 60);
    return this.format(arg2, seconds, minutes, hours);
  }

  private format(arg2, seconds, minutes, hours): string {
    const secondsString = seconds < 10 ? '0' + seconds : seconds + '';
    const minutesString = minutes < 10 ? '0' + minutes : minutes + '';
    const hoursString = hours < 10 ? '0' + hours : hours + '';
    switch (arg2) {
      case 'hhmmss':
        return `${hoursString}h${minutesString}m${secondsString}s`;
      case 'hh:mm':
        return `${hoursString}:${minutesString}`;
      case 'hhmm':
        if (hours === 0) {
          return `${minutesString} min`;
        }
        return `${hours} h ${minutesString}`;
    }
    throw Error('invalid format');
  }
}
